import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    standalone: true,
})
export class MediaItem {
    @Input() roundedCorners: [boolean, boolean, boolean, boolean] | boolean = false;

    @HostBinding('class.sir-rounded-upper-left')
    get roundedUpperLeft(): boolean {
        return Array.isArray(this.roundedCorners) && this.roundedCorners[0];
    }

    @HostBinding('class.sir-rounded-upper-right')
    get roundedUpperRight(): boolean {
        return Array.isArray(this.roundedCorners) && this.roundedCorners[1];
    }

    @HostBinding('class.sir-rounded-lower-right')
    get roundedLowerRight(): boolean {
        return Array.isArray(this.roundedCorners) && this.roundedCorners[2];
    }

    @HostBinding('class.sir-rounded-lower-left')
    get roundedLowerLeft(): boolean {
        return Array.isArray(this.roundedCorners) && this.roundedCorners[3];
    }

    @HostBinding('class.sir-rounded-all')
    get roundedAll(): boolean {
        return typeof this.roundedCorners === 'boolean' && this.roundedCorners;
    }
}
